<template>
  <v-btn
    :id="id"
    :type="type"
    :class="bindClass"
    :width="width"
    :height="height"
    :loading="loading"
    :disabled="disabled"
    :to="to"
    :depressed="depressed"
    @click.stop="btnClick()"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'default',
    },
    classes: {
      type: Array,
      default() {
        return []
      },
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '52px',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
    },
    type: {
      type: String,
      default: 'button',
    },
    depressed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colorSet: {
        default: 'btn--default',
        black: 'btn--black',
        white: 'btn--white',
        green: 'btn--green',
        gray: 'btn--gray',
        pinkred: 'btn--pink',
      },
    }
  },
  computed: {
    colorClass() {
      return this.colorSet[this.color]
    },
    bindClass() {
      const d = ['basic-button', 'font--m-6']
      return [...d, this.colorClass, ...this.classes]
    },
  },
  methods: {
    btnClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
// @import '@/assets/scss/common/_variables.scss';

button:disabled,
.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: $gray-40 !important;
  color: $white !important;
}

.basic-button {
  line-height: 1.4;
}
</style>
